import BaseAdapter from "@/adapters/base";
import store from "@/store";
import { AxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';
import User from "@/models/User";
import Address from "@/models/Address";

export default class SignupAdapter extends BaseAdapter {

    public startSignup(user: User, address: Address): Promise<User> {
        return new Promise(((resolve, reject) => {
            const url = `/users/signup`;
            this.request({
                method: 'post',
                url,
                data: {
                    user,
                    address,
                },
            }).then( (res: AxiosResponse) => {
                resolve(res.data);
            }).catch((error: AxiosError) => {
                reject(error);
            });
        }));
    }

}
